/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `skip` - skip
 * * `filter_options` - filter_options
 * * `default_value` - default_value
 * @export
 */
export const CustomQuestionnaireQuestionRuleTypeEnum = {
  skip: 'skip',
  filterOptions: 'filter_options',
  defaultValue: 'default_value',
} as const;
export type CustomQuestionnaireQuestionRuleTypeEnum =
  (typeof CustomQuestionnaireQuestionRuleTypeEnum)[keyof typeof CustomQuestionnaireQuestionRuleTypeEnum];

export function instanceOfCustomQuestionnaireQuestionRuleTypeEnum(value: any): boolean {
  for (const key in CustomQuestionnaireQuestionRuleTypeEnum) {
    if (Object.prototype.hasOwnProperty.call(CustomQuestionnaireQuestionRuleTypeEnum, key)) {
      if (
        (CustomQuestionnaireQuestionRuleTypeEnum as Record<string, CustomQuestionnaireQuestionRuleTypeEnum>)[key] ===
        value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function CustomQuestionnaireQuestionRuleTypeEnumFromJSON(json: any): CustomQuestionnaireQuestionRuleTypeEnum {
  return CustomQuestionnaireQuestionRuleTypeEnumFromJSONTyped(json, false);
}

export function CustomQuestionnaireQuestionRuleTypeEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CustomQuestionnaireQuestionRuleTypeEnum {
  return json as CustomQuestionnaireQuestionRuleTypeEnum;
}

export function CustomQuestionnaireQuestionRuleTypeEnumToJSON(
  value?: CustomQuestionnaireQuestionRuleTypeEnum | null,
): any {
  return value as any;
}
